const calculateParameterValue = ({ y, bounds, bipolar, incrementCount }) => {
   const ratio = (y - bounds.bottom) / (bounds.top - bounds.bottom);

   if (incrementCount == null && bipolar) {
      return ratio * 2 - 1;
   }
   if (incrementCount == null) {
      return ratio;
   }
   if (bipolar) {
      return Math.round(incrementCount * ratio * 2) / incrementCount - 1;
   }
   return Math.round(incrementCount * ratio) / incrementCount;
};

export { calculateParameterValue };
